window.clientId = "MYJX"
document.addEventListener("DOMContentLoaded", function () {
  // Load Leaflet.js dynamically
  var leafletScript = document.createElement("script")
  leafletScript.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"

  // After Leaflet is loaded, load MarkerCluster and initialize the LocationsApp
  leafletScript.onload = () => {
    // Load MarkerCluster after Leaflet has loaded
    var clusterScript = document.createElement("script")
    clusterScript.src =
      "https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js"
    clusterScript.onload = () => {
      window.locationsApp = new LocationsApp() // Now initialize LocationsApp
    }
    document.head.appendChild(clusterScript)

    // Load MarkerCluster CSS after Leaflet is loaded
    var clusterStyle = document.createElement("link")
    clusterStyle.href =
      "https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css"
    clusterStyle.rel = "stylesheet"
    document.head.appendChild(clusterStyle)
  }
  document.head.appendChild(leafletScript)

  // Load Turf.js dynamically
  var turfScript = document.createElement("script")
  turfScript.src = "https://unpkg.com/@turf/turf/turf.min.js"
  document.head.appendChild(turfScript)

  // Load Leaflet CSS dynamically
  var leafletStyle = document.createElement("link")
  leafletStyle.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
  leafletStyle.rel = "stylesheet"
  document.head.appendChild(leafletStyle)

  // Create the map container
  var mapContainer = document.getElementById("map")
})

class LocationsApp {
  constructor() {
    this.api_url = `https://cdn.shopify.com/s/files/1/0070/8388/4615/files/stores.json`
    this.icons = []
    this.markers = []
    this.debounceTimeout = null
    this.config = {}
    this.currentLocation = []
    this.mapLoading(true)

    this.currentLocation = [-118.2437, 34.0522]
    this.initMap([-118.2437, 34.0522]).then(({ map }) => {
      this.map = map

      this.mapLoading(false)
      this.loadLocations()

      this.initListeners()
    })

    this.getClientLocation().then((coordinates) => {
      this.currentLocation = coordinates
      if (this.map)
        this.map.setView([coordinates[1], coordinates[0]], this.map.getZoom())
      this.search(null, coordinates[1], coordinates[0])
    })
  }

  setZoom(distance) {
    // Remove any existing circle layer
    if (distance === 0) {
      return
    }

    if (this.map.circleLayer) {
      this.map.removeLayer(this.map.circleLayer)
    }

    // Convert miles to meters (1 mile = 1609.34 meters)
    var radiusMeters = distance * 1609.34
    var center = L.latLng(this.currentLocation[1], this.currentLocation[0])
    // Create a circle with the user-selected distance
    var circle = L.circle(center, { radius: radiusMeters }).addTo(this.map)

    // Store circle layer to remove it next time
    this.map.circleLayer = circle

    // Get the bounds of the circle
    var bounds = circle.getBounds()

    // Fit the map bounds to the circle (zooming to show the full radius)
    this.map.fitBounds(bounds)
  }

  mapLoading(loading) {
    const loader = document.getElementById("loader")
    loader.style.display = loading ? "block" : "none"
  }

  initMap(coordinates) {
    return new Promise((resolve) => {
      const map = L.map("map").setView([coordinates[1], coordinates[0]], 10)
      this.search(null, coordinates[1], coordinates[0])

      // L.tileLayer("https://d2dn0iff114oao.cloudfront.net/tiles/{z}/{x}/{y}/tile.png", {
      // L.tileLayer("https://cdn.pwtech.io/tiles/{z}/{x}/{y}/tile.png", {
      //   attribution:
      //     '&copy; <a href="https://carto.com/attributions">Carto</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      //   maxZoom: 20,
      //   minZoom: 0,
      // }).addTo(map)

      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_43tf_1_3a761a40bd3601e3b6e3066a",
        {
          attribution:
            '&copy; <a href="https://carto.com/attributions">Carto</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          maxZoom: 20,
          minZoom: 0,
          subdomains: "abcd",
        },
      ).addTo(map)

      resolve({ map })
    })
  }

  loadLocations() {
    fetch(this.api_url)
      .then((res) => res.json())
      .then((geojsonData) => {
        const locations = L.markerClusterGroup() // Initialize marker cluster group

        // Create a GeoJSON layer and add it to the marker cluster group
        const geoJsonLayer = L.geoJSON(geojsonData, {
          onEachFeature: (feature, layer) => {
            // Bind popups or other interactions for each feature
            if (feature.properties) {
              layer.bindPopup(`
                <div class="popup">
                  <h2>${feature.properties.name}</h2>
                  <p>${feature.properties.full_address}</p>
                  <a href="https://www.google.com/maps/dir/?api=1&origin=${this.currentLocation[1]},${this.currentLocation[0]}&destination=${feature.geometry.coordinates[1]},${feature.geometry.coordinates[0]}" target="_blank">
                    Get Directions
                  </a>
                </div>
              `)

              // on click function
              layer.on("click", () => {
                // scroll and highlight location in the list
                const locationElement = document.getElementById(feature.properties.id)

                // Find the scrollable container
                const scrollableContainer = document.getElementById("locations") // Ensure this is your scrollable container's ID

                // Calculate the position of the element relative to the scrollable container
                const containerTop = scrollableContainer.getBoundingClientRect().top
                const elementTop = locationElement.getBoundingClientRect().top

                // Adjust the scroll position of the container to center the element
                const scrollOffset =
                  elementTop -
                  containerTop -
                  scrollableContainer.clientHeight / 2 +
                  locationElement.clientHeight / 2

                // Smoothly scroll the container to the calculated position
                scrollableContainer.scrollBy({ top: scrollOffset, behavior: "smooth" })

                // Highlight the clicked location
                this.listHighlight(locationElement)
              })
            }
          },
          pointToLayer: (feature, latlng) => {
            const marker = L.marker(latlng, {
              icon: L.icon({
                iconUrl: feature.properties.icon,
                iconSize: [30, 30],
                iconAnchor: [15, 30],
                popupAnchor: [0, -30],
                crossOrigin: "anonymous",
              }),
            })
            marker.feature = feature
            this.markers.push({ id: feature.properties.id, marker })
            return marker
          },
        })

        // Add the GeoJSON layer to the marker cluster group
        locations.addLayer(geoJsonLayer)

        // Add the marker cluster group to the map
        this.map.addLayer(locations)

        this.renderLocations()
      })
      .catch((error) => console.error("Error loading GeoJSON data:", error))
  }

  renderLocations(delay = 500) {
    setTimeout(() => {
      const container = document.getElementById("locations")
      container.innerHTML = ""

      // Get the current map bounds (visible area)
      const bounds = this.map.getBounds()

      // Iterate over each layer in the map
      this.map.eachLayer((layer) => {
        // Check if the layer is a marker and has latlng
        if (layer instanceof L.Marker && layer._latlng && layer.feature) {
          // Check if the marker is within the current bounds
          if (bounds.contains(layer.getLatLng())) {
            // Get marker details from the feature
            const latlng = layer.getLatLng()
            const feature = layer.feature // Assuming `feature` was attached to the marker

            // You can customize this further based on how you're fetching and storing marker data
            const name = feature?.properties?.name || "Unknown"
            const address = feature?.properties?.full_address || "No address available"
            const distance =
              turf
                .distance([latlng.lng, latlng.lat], this.currentLocation, {
                  units: "miles",
                })
                .toFixed(2) + " mi"

            // Render the location element only for markers currently in the map bounds
            const locationElement = document.createElement("div")
            locationElement.className = "location"
            locationElement.id = feature.properties.id
            locationElement.innerHTML = `
              <div class="row">
                <img src="${feature.properties.icon}" width="30" height="30" alt="${name}" />
                <h2>${name}</h2>
                <div class="distance">
                  <p>${distance}</p>
                </div>
              </div>
              <div>
                <p>${address}</p>
                <a href="https://www.google.com/maps/dir/?api=1&origin=${this.currentLocation[1]},${this.currentLocation[0]}&destination=${latlng.lat},${latlng.lng}" target="_blank">
                  Get Directions
                </a>
              </div>
            `
            locationElement.addEventListener("click", () => {
              layer.openPopup()
              this.listHighlight(locationElement)
            })
            container.appendChild(locationElement)
          }
        }
      })
      const highlightedElement = document.getElementById(this.highlightedId)
      if (highlightedElement) {
        this.listHighlight(highlightedElement)
      }
      if (container.children.length === 0) {
        document.getElementById("no-locations").style.display = "block"
      } else {
        document.getElementById("no-locations").style.display = "none"
      }
    }, delay)
  }

  listHighlight(locationElement) {
    this.highlightedId = locationElement.id
    // Remove highlight from all locations
    document.querySelectorAll(".location").forEach((locationElement) => {
      locationElement.classList.remove("highlight")
    })

    // remove active class from all icons
    document.querySelectorAll(".leaflet-marker-icon").forEach((icon) => {
      icon.classList.remove("active")
    })
    // highlight the icon
    const marker = this.markers.find((marker) => marker.id === locationElement.id)
    if (marker) {
      marker.marker._icon.classList.add("active")
    }

    // Highlight the clicked location
    locationElement.classList.add("highlight")
  }

  getIconImage(name) {
    const icon = this.icons.find((icon) => icon.name === name)
    return icon ? icon.src : ""
  }

  initListeners() {
    this.map.on("moveend", () => {
      this.renderLocations()
    })
  }

  async getClientLocation() {
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve([position.coords.longitude, position.coords.latitude])
        },
        () => {
          resolve([-118.2437, 34.0522]) // Default to Los Angeles if location is unavailable
        },
      )
    })
  }

  async getLatLongByZipCode(zipCode) {
    // const proxyUrl = "https://cors.amenbond.tech/proxy?url=" // Free CORS proxy
    // const targetUrl = `https://api.zippopotam.us/us/${zipCode}`
    // const url = proxyUrl + encodeURIComponent(targetUrl)

    const url = `https://endrock.novapower.io/endrockapi/v3/app/search/us/${zipCode}`

    try {
      if (!zipCode) throw new Error("Zip code is required")

      const response = await fetch(url)
      if (!response.ok) throw new Error(`Error: ${response.status}`)
      const data = await response.json()
      // const latitude = data.places[0].latitude;
      // const longitude = data.places[0].longitude;
      const place = data.places[0]
      return place
    } catch (error) {
      console.error("Failed to fetch:", error)
      return null
    }
  }

  search(zipCode = null, lat = null, lng = null) {
    // search for locations
    // debounce
    if (zipCode) {
      const zipPattern = /^\d{5}(-\d{3})?$/
      if (!zipPattern.test(zipCode)) {
        return
      }
    }
    if (this.map && this.map.circleLayer) {
      this.map.removeLayer(this.map.circleLayer)
    }
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(async () => {
      const place = await this.getLatLongByZipCode(zipCode)

      if (!place) return

      // move map to result
      // flip the coordinates
      const center = [place.latitude, place.longitude]
      this.map.setView(center, 14)
      this.currentLocation = [place.longitude, place.latitude]
      this.renderResult(place)
    }, 500)
  }

  renderResult(place) {
    document.getElementById("your-location").innerHTML = `
      <strong>Your Location:</strong> ${place["place name"]}
    `
  }
}
